//Headroom
import Headroom from 'headroom.js/dist/headroom';

function customHeadroom() {
  const header = document.getElementById("site-header");

  if (header) {
    const hd = new Headroom(header, {
      offset : 200,
    });
    hd.init();
  }
}

export default customHeadroom
